import {
  notifyWindowCapReached,
  windowStack,
  windowTaskbarTextLabel,
} from "@/app/shell/windowStack";
import type { DatasetSection } from "../feature/datasetSections";

/** `datasetDetail` kind 엔트리의 params 계약. 콘텐츠가 읽고 여는 쪽이 채운다 — 한 곳에서만 정의해 drift 를 막는다. */
export type DatasetDetailWindowParams = {
  datasetUuid: string;
  /** 처음 보여 줄 섹션. 없으면 개요. */
  initialSection?: DatasetSection;
  /** 처음 고를 Probe. 없으면 가장 최근 건. */
  initialProbeUuid?: string;
};

export const DATASET_DETAIL_WINDOW_KIND = "datasetDetail";

export type OpenDatasetDetailWindowInput = DatasetDetailWindowParams & {
  /** 작업표시줄 · 창 제목. 데이터를 받은 뒤 콘텐츠가 서버 값으로 보정한다. */
  displayName: string;
};

/**
 * Dataset 상세를 전체화면 창 스택으로 연다(목록 카드 · 행 클릭, 등록 직후). 같은 Dataset 이 이미
 * 떠 있으면 그 창을 복원하고(창 안 상태 보존), cap(5) 초과면 열지 않고 toast 로 안내한다.
 */
export function openDatasetDetailWindow(input: OpenDatasetDetailWindowInput): void {
  const params: DatasetDetailWindowParams = {
    datasetUuid: input.datasetUuid,
    initialSection: input.initialSection,
    initialProbeUuid: input.initialProbeUuid,
  };
  const id = windowStack.open({
    kind: DATASET_DETAIL_WINDOW_KIND,
    key: input.datasetUuid,
    title: input.displayName,
    label: windowTaskbarTextLabel("Dataset:", input.displayName),
    params,
  });
  if (id === null) {
    notifyWindowCapReached();
  }
}
